<rotec-modal-v2
  [title]="edit ? 'Edit Task' : 'Add New Tooling Task'"
  [darkMode]="true"
  [disablePaddingMainPart]="true"
  width="80vw"
  height="95vh"
  class="modal"
>
  <ng-container ngProjectAs="modal-main" class="modal-main">
    <div class="modal-container">
      <div class="workflow-header">
        <rotec-workflow
          [darkMode]="true"
          [nextButtonClick$]="nextClick$"
          [previousButtonClick$]="previousClick$"
          [items]="workflowItems"
          [horizontal]="true"
          [checkOnValid]="true"
          (selectedItemChange)="stepChanged($event)"
        ></rotec-workflow>
      </div>
      <div class="workflow-content" #content>
        @if (backendError) {
          <rotec-notification-v2 type="error" [darkMode]="true" class="error">
            {{ backendError | translate }}
          </rotec-notification-v2>
        }

        @switch (activeStep.title) {
          @case ('Tooling') {
            <ma-tooling-step
              #steps
              [toolingSearchService]="toolingSearchService"
              [edit]="edit"
              [height]="content.clientHeight"
            ></ma-tooling-step>
          }
          @case ('Description') {
            <div class="step">
              <ma-tooling-description-step
                #steps
                [fileUploader]="fileUploader"
                [toolingTaskModel]="toolingTaskModel"
                (toolingTaskModelChange)="toolingTaskModel = $event"
              ></ma-tooling-description-step>
            </div>
          }
          @case ('Scheduling') {
            <div class="step scheduling">
              <ma-tooling-scheduling-step
                #steps
                [toolingTaskModel]="toolingTaskModel"
                (toolingTaskModelChange)="toolingTaskModel = $event"
                class="step"
              ></ma-tooling-scheduling-step>
            </div>
          }
          @case ('Documents') {
            <div class="step documents">
              <ma-tooling-documents-step
                #steps
                [toolingTaskModel]="toolingTaskModel"
                (toolingTaskModelChange)="toolingTaskModel = $event"
                class="step"
              ></ma-tooling-documents-step>
            </div>
          }
        }
      </div>
    </div>
  </ng-container>

  <ng-container ngProjectAs="modal-buttons">
    <button rotec-button-secondary dark class="button cancel" (click)="close()">
      {{ 'COMMON_Cancel' | translate }}
    </button>
    @if (leftSaveButtonActive) {
      <div class="button left-save">
        <ng-container *ngTemplateOutlet="saveButton"></ng-container>
      </div>
    }
    <button
      rotec-button-primary-v2
      dark
      class="button back"
      [disabled]="previousButtonDisabled || (loading$ | async)"
      (click)="previousClick$.next()"
    >
      {{ 'COMMON_Back' | translate }}
    </button>
    @if (!createButton) {
      <button
        rotec-button-active
        dark
        class="button next"
        [disabled]="nextButtonDisabled || (loading$ | async)"
        (click)="nextClick$.next()"
      >
        {{ 'COMMON_Next' | translate }}
      </button>
    } @else {
      <button
        rotec-button-active
        dark
        class="button next"
        [disabled]="nextButtonDisabled || (loading$ | async)"
        (click)="submitToolingTask()"
      >
        {{ 'COMMON_Save' | translate }}
      </button>
    }
    <ng-template #saveButton>
      <button
        rotec-button-active
        dark
        class="button next"
        [disabled]="nextButtonDisabled || (loading$ | async)"
        (click)="submitToolingTask()"
      >
        {{ 'COMMON_Save' | translate }}
      </button>
    </ng-template>
  </ng-container>
</rotec-modal-v2>
